import { SvgIcon, SvgIconProps } from "@mui/material";

export default function RfhLogo(props: Readonly<SvgIconProps>): JSX.Element {
  const { style, ...otherProps } = props;

  return (
    <SvgIcon
      aria-label={"rfh logo"}
      viewBox="0 0 307.58 163.73"
      style={{
        color: "#fff",
        height: "100%",
        width: 75,
        marginBottom: 5,
        ...style,
      }}
      {...otherProps}
    >
      <path
        d="M107.55,62.88a53.34,53.34,0,0,1,12.79,34.83,53.9,53.9,0,0,1-48.76,53.58,53.33,53.33,0,0,1-12.79-34.83,53.89,53.89,0,0,1,48.76-53.58m5.06-12.44A66,66,0,0,0,66.51,163.73,66,66,0,0,0,112.6,50.44"
        transform="translate(0)"
        fill="#0cc988"
      />
      <path
        d="M172.86,80.89l-8.23-9.37h-1.95v9.37h-6.73V53.58h13.82c5.91,0,9.82,3.59,9.82,8.93,0,4.48-2.77,7.7-7.17,8.68l8.56,9.7Zm-3.83-15c2.41,0,4-1.3,4-3.3s-1.55-3.26-4-3.26h-6.35v6.56Z"
        transform="translate(0)"
      />
      <path
        d="M204.83,70.69c0,6.48-5.14,10.8-11.21,10.8s-11.33-4.32-11.33-10.8,5.14-10.76,11.33-10.76,11.21,4.32,11.21,10.76m-6.28,0a5,5,0,1,0,0,.53,5,5,0,0,0,0-.53"
        transform="translate(0)"
      />
      <path
        d="M217.5,87.88h-7.05l3.3-7.62-8.47-19.81h7l4.85,11.95,5.18-11.95h7Z"
        transform="translate(0)"
      />
      <path
        d="M252.7,80.92h-6.52V79.29a9.21,9.21,0,0,1-6.36,2.24c-5.42,0-10-4.36-10-10.84s4.57-10.84,10-10.84a9.21,9.21,0,0,1,6.36,2.24V60.46h6.52Zm-6.52-10.23a5.1,5.1,0,0,0-4.9-5.3h-.12c-2.85,0-4.93,2.16-4.93,5.3s2.08,5.3,4.93,5.3a5.08,5.08,0,0,0,5-5.14Q246.18,70.77,246.18,70.69Z"
        transform="translate(0)"
      />
      <path d="M257.92,80.88h6.52V51.53h-6.52Z" transform="translate(0)" />
      <path
        d="M162.65,104.75h12.8v5.87h-12.8v9.78h-6.72V93.09H177V99H162.65Z"
        transform="translate(0)"
      />
      <path d="M180.17,120.4h6.52V91h-6.52Z" transform="translate(0)" />
      <path
        d="M212.9,110.19c0,6.48-5.14,10.8-11.21,10.8s-11.33-4.32-11.33-10.8,5.14-10.76,11.33-10.76,11.21,4.32,11.21,10.76m-6.28,0a5,5,0,1,0-4.93,5.3,5.09,5.09,0,0,0,4.93-5.24v-.06"
        transform="translate(0)"
      />
      <path
        d="M231.63,99.83l-.29,6.52h-1.18c-4.56,0-7.05,2.36-7.05,7.66v6.4H216.6V100h6.52v3.91a7.91,7.91,0,0,1,7.05-4.2,5.58,5.58,0,0,1,1.47.16"
        transform="translate(0)"
      />
      <path
        d="M256.31,120.42h-6.52v-1.63a9.21,9.21,0,0,1-6.36,2.24c-5.42,0-10-4.36-10-10.84s4.57-10.85,10-10.85a9.22,9.22,0,0,1,6.36,2.24V100h6.52Zm-6.52-10.23a5.1,5.1,0,0,0-4.9-5.3h-.12c-2.86,0-4.93,2.16-4.93,5.3s2.08,5.3,4.93,5.3a5.08,5.08,0,0,0,5-5.14Q249.79,110.27,249.79,110.19Z"
        transform="translate(0)"
      />
      <path
        d="M180.85,159.95h-6.68v-10.8h-11.5v10.8h-6.72V132.64h6.73v10.64h11.5V132.64h6.68Z"
        transform="translate(0)"
      />
      <path
        d="M207.2,149.72c0,6.48-5.14,10.8-11.21,10.8s-11.33-4.32-11.33-10.8S189.79,139,196,139s11.21,4.32,11.21,10.76m-6.28,0A5,5,0,1,0,196,155a5.09,5.09,0,0,0,4.93-5.24v-.06"
        transform="translate(0)"
      />
      <path d="M210.89,159.95h6.52V130.6h-6.52Z" transform="translate(0)" />
      <path d="M222.21,159.95h6.52V130.6h-6.52Z" transform="translate(0)" />
      <path
        d="M255.36,159.95h-6.52v-1.63a9.21,9.21,0,0,1-6.36,2.24c-5.42,0-10-4.36-10-10.84s4.57-10.84,10-10.84a9.21,9.21,0,0,1,6.36,2.24v-1.63h6.52Zm-6.52-10.23a5.1,5.1,0,0,0-4.9-5.3h-.12c-2.85,0-4.93,2.16-4.93,5.3s2.08,5.3,4.93,5.3a5.08,5.08,0,0,0,5-5.14Q248.84,149.8,248.83,149.72Z"
        transform="translate(0)"
      />
      <path
        d="M281.31,147.39V160h-6.48V148.78c0-2.4-1.43-4-3.5-4-2.57,0-4.24,1.75-4.24,5.7v9.5h-6.52V139.48h6.52v2a8.44,8.44,0,0,1,6.28-2.57c4.77,0,7.95,3.38,7.95,8.52"
        transform="translate(0)"
      />
      <path
        d="M307.58,159.95h-6.52v-1.63a9.21,9.21,0,0,1-6.36,2.24c-5.42,0-10-4.36-10-10.84s4.57-10.84,10-10.84a9.21,9.21,0,0,1,6.36,2.24V130.6h6.52Zm-6.52-10.23a5.1,5.1,0,0,0-4.9-5.3H296c-2.85,0-4.93,2.16-4.93,5.3s2.08,5.3,4.93,5.3a5.08,5.08,0,0,0,5-5.14Q301.06,149.8,301.05,149.72Z"
        transform="translate(0)"
      />
      <path
        d="M61.51,30.46h10V0h-10Z"
        transform="translate(0)"
        fill="#3a4d41"
      />
      <path
        d="M43,34.41,36,10l9.6-2.75,7,24.42Z"
        transform="translate(0)"
        fill="#3a4d41"
      />
      <path
        d="M26.66,43.23,15.86,25.95l8.46-5.29,10.8,17.28Z"
        transform="translate(0)"
        fill="#3a4d41"
      />
      <path
        d="M89.78,34.41l-9.59-2.75,7-24.42L96.78,10Z"
        transform="translate(0)"
        fill="#3a4d41"
      />
      <path
        d="M106.26,43.23l-8.46-5.29,10.8-17.28,8.46,5.28Z"
        transform="translate(0)"
        fill="#3a4d41"
      />
      <path
        d="M19.93,50.44A66,66,0,0,0,66,163.73,65.82,65.82,0,0,0,86,116.46a66,66,0,0,0-66-66M25,62.88a53.9,53.9,0,0,1,48.77,53.58A53.34,53.34,0,0,1,61,151.29,53.89,53.89,0,0,1,12.2,97.71,53.34,53.34,0,0,1,25,62.88"
        transform="translate(0)"
        fill="#3a4d41"
      />
    </SvgIcon>
  );
}
